module.exports = __webpack_public_path__ + "assets/img/AmieJones.5de29de5.jpg";